import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Text} from '@dropbox/dig-components/typography';
import styles from 'views/roadmap/Roadmap.module.css';

const AUDIT_SKELETON_ROWS = 7;

export const AuditFindingsLoadingSkeleton = ({minimumHeight}: {minimumHeight?: number}) => (
  <div
    className={styles.auditFindingsLoading}
    data-testid="audit-findings-loading-skeleton"
    role="status"
    aria-label="Loading audit findings"
    style={minimumHeight ? {minHeight: minimumHeight} : undefined}
  >
    <div className={styles.auditFindingsLoadingControls} aria-hidden="true">
      <Skeleton.Box height={32} width={280} />
      <Skeleton.Box height={32} width={120} />
    </div>
    <div className={styles.auditFindingsLoadingChips} aria-hidden="true">
      {[72, 132, 116, 144].map((width) => (
        <Skeleton.Box key={width} height={28} style={{borderRadius: 999, width}} />
      ))}
    </div>
    <div className={styles.auditFindingsLoadingTableShell} aria-hidden="true">
      <div className={styles.auditFindingsLoadingTable}>
        <div className={styles.auditFindingsLoadingTableHeader}>
          {['Initiative', 'DRI', 'Status', 'Start Date', 'End Date', 'Flag'].map((label) => (
            <Text key={label} size="small" isBold>
              {label}
            </Text>
          ))}
        </div>
        {Array.from({length: AUDIT_SKELETON_ROWS}).map((_, index) => (
          <div className={styles.auditFindingsLoadingTableRow} key={index}>
            <Skeleton.Box height={16} style={{width: index % 2 === 0 ? '78%' : '62%'}} />
            <Skeleton.Box height={16} width={108} />
            <Skeleton.Box height={22} width={84} style={{borderRadius: 999}} />
            <Skeleton.Box height={16} width={76} />
            <Skeleton.Box height={16} width={76} />
            <Skeleton.Box height={22} width={118} style={{borderRadius: 999}} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
